/**
 *FullScreen
 * https://developer.mozilla.org/ja/docs/Web/API/Fullscreen_API/Guide
 */
export class FullScreen {
    includeElement: JQuery<HTMLElement>;
    includeElementClone: JQuery<HTMLElement>;
    includeElementParent: JQuery<any>;

    /** */
    public static get inFullScreen(): boolean {
        // document.fullscreenElement は、全画面モードにある要素があれば
        // それを指します。要素がなければ、このプロパティの値は null になります。
        if (document.fullscreenElement) {
            return true;
        } else {
            return false;
        }
    }

    /** */
    _el: HTMLElement;

    /** */
    public get el(): HTMLElement {
        return this._el;
    }

    /** */
    public set el(value: HTMLElement) {
        this._el = value;
    }

    /** */
    public get $el(): JQuery<HTMLElement> {
        return $(this._el);
    }

    /** */
    public get inFullScreen(): boolean {
        return FullScreen.inFullScreen;
    }

    /** */
    public onFullscreenchange: (event: any, inFullScreen: boolean) => void;

    /**
     * ctor
     */
    constructor(_targetElement: JQuery<HTMLElement>, includeElement?: any) {
        this.el = $(_targetElement).get(0);

        this.includeElement = includeElement ? $(includeElement) : null;
        this.includeElementParent = this.includeElement?.parent() || null;
        //this.el.addEventListener("fullscreenchange", this.fullscreenchangedHandler.bind(this));
        // or
        this.el.onfullscreenchange = this.fullscreenchangedHandler.bind(this);
    }

    /**
      * フルスクリーンにする
      */
    requestFullScreen(): Promise<void> {
        if (!document.fullscreenElement) {

            return this.el.requestFullscreen();
        }
        return new Promise<void>((rs, rj) => rs());

    };

    /**
     * フルスクリーン解除
     */
    exitFullScreen(): Promise<void> {
        if (document.exitFullscreen) {
            return document.exitFullscreen();
        }
        return new Promise<void>((rs, rj) => rs());
    };

    /**
     *
     */
    toggleFullScreen() {
        if (!document.fullscreenElement) {
            this.el.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }



    /**
     *
     * @param event
     */
    private fullscreenchangedHandler(event) {
        // document.fullscreenElement は、全画面モードにある要素があれば
        // それを指します。要素がなければ、このプロパティの値は null になります。
        if (this.includeElement) {
            if (this.inFullScreen) {
                //this.includeElementClone = this.includeElement.clone(true, true);
                //this.$el.prepend(this.includeElementClone);
                this.includeElement.detach();
                this.$el.prepend(this.includeElement);
            } else {
                this.includeElement.appendTo(this.includeElementParent);
            }
        }

        this.onFullscreenchange?.call(this, event, this.inFullScreen);
    }

}
